import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, backTo }) => {
  const navigate = useNavigate();

  return (
    <header className="w-full flex items-center gap-3 px-4 py-3 border-b bg-white sticky top-0 z-50">
      {/* Back Button */}
      <button
        onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
        className="p-2 rounded-full hover:bg-gray-100 transition"
        aria-label="Go Back"
      >
        <ArrowLeft className="w-5 h-5 text-gray-700" />
      </button>

      {/* Title */}
      <h1 className="text-lg sm:text-xl font-semibold text-gray-800 truncate">
        {title}
      </h1>
    </header>
  );
};

export default PageHeader;
